<script>
  import { _ } from '@sveltia/i18n';
  import { EmptyState, Group, InfiniteScroll } from '@sveltia/ui';
  import { sleep } from '@sveltia/utils/misc';

  import ListingGrid from '$lib/components/common/listing-grid.svelte';
  import EntryResultItem from '$lib/components/search/entry-result-item.svelte';
  import { announcedPageStatus } from '$lib/services/app/navigation';
  import { searchTerms } from '$lib/services/search';
  import { entrySearchResults } from '$lib/services/search/entries';

  /**
   * @import { EntrySearchResult } from '$lib/types/private';
   */

  $effect(() => {
    announcedPageStatus.current = _('viewing_entry_search_results', {
      values: {
        terms: searchTerms.current,
        count: entrySearchResults.current.length,
      },
    });
  });
</script>

<Group aria-labelledby="search-results-entries">
  <!-- <h3 role="none" id="search-results-entries">{_('entries')}</h3> -->
  <div role="none">
    {#if entrySearchResults.current.length}
      <ListingGrid
        viewType="list"
        aria-label={_('entries')}
        aria-rowcount={entrySearchResults.current.length}
      >
        {#key searchTerms.current}
          <InfiniteScroll items={entrySearchResults.current} itemKey="id">
            {#snippet renderItem(/** @type {EntrySearchResult} */ result)}
              {#await sleep() then}
                <EntryResultItem {result} />
              {/await}
            {/snippet}
          </InfiniteScroll>
        {/key}
      </ListingGrid>
    {:else if searchTerms.current}
      <EmptyState>
        <span role="none">{_('no_entries_found')}</span>
      </EmptyState>
    {/if}
  </div>
</Group>
